import Cookies from 'js-cookie';
import Moment from 'moment';
import EventEmitter from '../../components/modules/event-emitter/EventEmitter';
import Listener from '../../const/Listener';



export default {
  getRecentFlights,
  updateRecentFlights
};

const PREVIOUS_VISIT_COOKIE = 'previousVisit';

function getRecentFlights() {
  const cookiesFlight = Cookies.get(PREVIOUS_VISIT_COOKIE);
  const recentFlights = [];

  if (cookiesFlight) {
    cookiesFlight.split('#').forEach(flight => {
      if (flight) {
        const flightAttibutes = flight.split('|');
        const cabinCategory = flightAttibutes[12] === '' ? 'ECONOMY' : flightAttibutes[12];
        const typeOfFlight = flightAttibutes[13]

        recentFlights.push({
          typeTrip: flightAttibutes[0],
          flightOrigin: {
            code: flightAttibutes[1],
            searchCode: flightAttibutes[2],
            name: flightAttibutes[3]
          },
          flightDestiny: {
            code: flightAttibutes[4],
            searchCode: flightAttibutes[5],
            name: flightAttibutes[6]
          },
          startDate: flightAttibutes[7],
          endDate: flightAttibutes[8],
          totalAdults: Number(flightAttibutes[9]),
          totalKids: Number(flightAttibutes[10]),
          totalBabys: Number(flightAttibutes[11]),
          cabinCategory: cabinCategory,
          typeOfFlight: typeOfFlight,
          companiesIdentity: flightAttibutes[14]
        });
      }
    });
  }

  return recentFlights;
}

function updateRecentFlights(flightSearched) {
  const recentFlights = getRecentFlights();

  if (isRecentFlightUpdated(flightSearched, recentFlights[0])) {
    const newRecentFlights = recentFlights.slice();
    newRecentFlights.unshift(flightSearched);
    const newRecentFlightsCookie = newRecentFlights
      .slice(0, 3)
      .map(flight => getRecentFlightAsCookieString(flight))
      .reduce((a, b) => `${a}#${b}`);

    Cookies.set(PREVIOUS_VISIT_COOKIE, newRecentFlightsCookie, {
      path: '/',
      expires: Moment()
        .add(1, 'year')
        .toDate()
    });
    EventEmitter.emitEvent(Listener.RECENT_FLIGHTS);
  }
}

function getRecentFlightAsCookieString(flight) {
  const typeTrip = `${flight.typeTrip}|`;
  const flightOrigin = `${flight.flightOrigin.code}|${flight.flightOrigin.searchCode}|${
    flight.flightOrigin.name
  }|`;
  const flightDestiny = `${flight.flightDestiny.code}|${flight.flightDestiny.searchCode}|${
    flight.flightDestiny.name
  }|`;
  const dates = `${flight.startDate}|${flight.endDate ? flight.endDate : ''}|`;
  const passengers = `${flight.totalAdults}|${flight.totalKids}|${flight.totalBabys}|`;
  const cabinCategory = flight.cabinCategory ? `${flight.cabinCategory}|` : 'ECONOMY|';
  const typeOfFlight = flight.typeOfFlight ? `${flight.typeOfFlight}|` : `A|`;
  const companiesIdentity = flight.companiesIdentity ? `${flight.companiesIdentity}|` : `?|`
  return `${typeTrip}${flightOrigin}${flightDestiny}${dates}${passengers}${cabinCategory}${typeOfFlight}${companiesIdentity}`;
}

function isRecentFlightUpdated(newFlight, oldFlight) {
  return (
    !oldFlight ||
    getRecentFlightAsCookieString(newFlight) !== getRecentFlightAsCookieString(oldFlight)
  );
}



// WEBPACK FOOTER //
// ./src/services/flightHistory/FlightHistoryService.js